import './Event.scss';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Plot from 'react-plotly.js';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import io from 'socket.io-client';
import { TokenService } from '../../../services/token.service';
import { DataName, EventReport } from '../../../util/model';
import { actionUpdateLayerData } from '../../../redux/action/layerData';
import { RestApi } from '../../../services/restapi.service';
import { saveAs } from 'file-saver';
import Moment from "moment";
import { activityStatusAction } from "../../../redux/action/activity";

export default function Event() {
  let data_temp_init: Array<any> = [];
  data_temp_init.push({
    x: [],
    y: [],
    mode: 'markers',
    type: 'scatter',
  });
  let layout_temp = {
    margin: {
      l: 50,
      r: 30,
      b: 40,
      t: 30,
      pad: 0,
    },
    height: 500,
    font: { color: 'white', family: 'Arial' },
    title: {
      text: 'Max Rx Power',
      font: {
        color: 'white',
        size: 12,
      },
    },
    xaxis: {
      title: {
        text: 'Time',
        font: {
          color: 'white',
        },
      },
      autorange: true,
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    yaxis: {
      title: {
        text: 'Power (dB)',
        font: {
          color: 'white',
        },
      },
      autorange: true,
      tickcolor: 'white',
      tickfont: {
        color: 'white',
      },
      gridcolor: 'rgb(110, 110, 50)',
      mirror: true,
      linewidth: 1,
      linecolor: 'rgb(255, 255, 140)',
    },
    plot_bgcolor: 'black',
    paper_bgcolor: 'black',
  };

  async function onDownload(reportName: string) {
    const res = await RestApi.getReport(reportName);
    var blob = new Blob([(res as any).data], {
      type: 'text/plain;charset=utf-8',
    });
    saveAs(blob, reportName);
  }
  
  async function onView(reportName: string) {
    window.open(reportName);
  }

  function onDownloadEventListClick() {
    var list = 'SN,Band,Type,StartTime,Period,MaxPower,NumbOfIF,Report\n';
    for (var i = 0; i < reports.length; ++i) {
      list =
        list +
        '"' +
        reports[i].SN +
        '",' +
        '"' +
        reports[i].Band +
        '",' +
        '"' +
        reports[i].Type +
        '",' +
        '"' +
        reports[i].StartTime +
        '",' +
        reports[i].Period +
        ',' +
        reports[i].MaxPower +
        ',' +
        reports[i].NumbOfIF +
        ',' +
        '"' +
        reports[i].OfflineReport.replaceAll('/', '_') +
        '"\n';
    }
    var blob = new Blob([list], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, 'EventList_' + epoch + '.csv');
    dispatch(activityStatusAction("EventReportDownload") as any)
  }

  // const columns: GridColDef[] = [
  //   { field: "SN", headerName: "Sensor Node", width: 200 },
  //   { field: "Band", headerName: "Band", width: 70 },
  //   { field: "Type", headerName: "IF Type", width: 200 },
  //   { field: "StartTime", headerName: "Start Time", width: 200 },
  //   { field: "Period", headerName: "Period (sec)", type: "number", width: 70 },
  //   {
  //     field: "MaxPower",
  //     headerName: "Max Rx Power (dB)",
  //     type: "number",
  //     width: 170,
  //   },
  //   {
  //     field: "NumbOfIF",
  //     headerName: "Number of IF",
  //     type: "number",
  //     width: 170,
  //   },
  //   //{ field: 'URL', headerName: 'Report', width: 500, renderCell: (params) => (<a href={params.value}>{params.value}</a>) }
  //   {
  //     field: "URL",
  //     headerName: "Report",
  //     width: 500,
  //     renderCell: (params) => (
  //       <button onClick={() => onClick(params.value)}>DOWNLOAD</button>
  //     ),
  //   },
  // ];
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update the window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Define columns conditionally
  /*
  const columns: GridColDef[] =
    windowWidth <= 425
      ? [
          { field: "SN", headerName: "Sensor Node", width: 100 },
          { field: "Band", headerName: "Band", width: 100 },
          { field: "StartTime", headerName: "Start Time", width: 100 },
          {
            field: "URL",
            headerName: "Report",
            width: 100,
            renderCell: (params) => (
              <button onClick={() => onClick(params.value)}>DOWNLOAD</button>
            ),
          },
        ]
      : [
          { field: "SN", headerName: "Sensor Node", width: 200 },
          { field: "Band", headerName: "Band", width: 70 },
          { field: "Type", headerName: "IF Type", width: 200 },
          { field: "StartTime", headerName: "Start Time", width: 200 },
          {
            field: "Period",
            headerName: "Period (sec)",
            type: "number",
            width: 70,
          },
          {
            field: "MaxPower",
            headerName: "Max Rx Power (dB)",
            type: "number",
            width: 170,
          },
          {
            field: "NumbOfIF",
            headerName: "Number of IF",
            type: "number",
            width: 170,
          },
          //{ field: 'URL', headerName: 'Report', width: 500, renderCell: (params) => (<a href={params.value}>{params.value}</a>) }
          {
            field: "URL",
            headerName: "Report",
            width: 500,
            renderCell: (params) => (
              <button onClick={() => onClick(params.value)}>DOWNLOAD</button>
            ),
          },
        ];
        */

  const arr_init: Array<any> = [];
  const [reports, setReports] = useState(arr_init);
  const col_init: GridColDef[] = [];
  const [columns, setColumns] = useState(col_init);
  const [epoch, setEpoch] = useState("");
  const [data_period, setPeriodData] = useState(data_temp_init);
  const dispatch = useDispatch();
  const layerData = useAppSelector((state) => state.layerData);
  const Reports = layerData.report;

  useEffect(() => {
    const socket = io(window.location.host, {
      reconnectionDelayMax: 10000,
      path: '/api/socket',
      withCredentials: true,
      extraHeaders: {
        'Authorization': `Bearer ${TokenService.getToken()}`,
      }
    });
    socket!.emit('join', 'report');
    socket.on('report', (report: EventReport) => {
      dispatch(actionUpdateLayerData('report', report) as any)
console.log('report', report);
    });
    socket.io.on('reconnect', (attempt) => {
      socket!.emit('join', 'report');
    });
    return () => {
      socket!.emit('leave', '');
    };
  }, []);

  useEffect(() => {
    let col: GridColDef[] = [];
    if(windowWidth <= 1000) {
        col = [
            { field: "SN", headerName: "Sensor Node", width: 150 },
            { field: "Band", headerName: "Band", width: 50 },
            { field: "StartTime", headerName: "Start Time", width: 200 },
            {
                field: "OfflineReport",
                headerName: "Offline Report",
                width: 170,
                renderCell: (params) => (<button onClick={() => onDownload(params.value)}>DOWNLOAD</button>)
            },
            {
                field: "OnlineReport",
                headerName: "Online Report",
                width: 170,
                renderCell: (params) => (<button onClick={() => onView(params.value)}>View</button>)
            }
        ];
    } else {
        col = [
            { field: "SN", headerName: "Sensor Node", width: 150 },
            { field: "Band", headerName: "Band", width: 50 },
            { field: "Type", headerName: "IF Type", width: 150 },
            { field: "StartTime", headerName: "Start Time", width: 200 },
            { field: "Period", headerName: "Period (sec)", type: "number", width: 70 },
            { field: "MaxPower", headerName: "Max Rx Power (dB)", type: "number", width: 150 },
            { field: "NumbOfIF", headerName: "Number of IF", type: "number", width: 150 },
            {
                field: "OfflineReport",
                headerName: "Offline Report",
                width: 170,
                renderCell: (params) => (<button onClick={() => onDownload(params.value)}>DOWNLOAD</button>)
            },
            {
                field: "OnlineReport",
                headerName: "Online Report",
                width: 170,
                renderCell: (params) => (<button onClick={() => onView(params.value)}>VIEW</button>)
            }
        ];
    }
    let arr: Array<any> = [];
    let data_period_: Array<any> = [];
    for (var i = 0; i < Reports.L1.length; ++i) {
      let data_period_x: Array<any> = [];
      let data_period_y: Array<any> = [];
      let data_period_onlineReport: Array<any> = [];
      for (var j = 0; j < Reports.L1[i].length; ++j) {
        if(windowWidth <= 1000) {
            arr.push({'reportID':Reports.L1[i][j].reportID, 'SN':Reports.L1[i][j].SN, 'Band':Reports.L1[i][j].Band, 'StartTime':Reports.L1[i][j].StartTime, 'OfflineReport':Reports.L1[i][j].OfflineReport, 'OnlineReport':Reports.L1[i][j].OnlineReport});
        } else {
            arr.push(Reports.L1[i][j]);
        }
        data_period_x.push(Reports.L1[i][j].StartTime);
        data_period_y.push(Reports.L1[i][j].MaxPower);
        data_period_onlineReport.push(Reports.L1[i][j].OnlineReport);
      }
      if (Reports.L1[i].length > 0) {
        data_period_.push({
          onlineReport: data_period_onlineReport,
          x: data_period_x,
          y: data_period_y,
          mode: 'markers',
          type: 'scatter',
          name: Reports.L1[i][0].SN + ' ' + Reports.L1[i][0].Band,
        });
      }
    }
    for (var i = 0; i < Reports.L2.length; ++i) {
      let data_period_x: Array<any> = [];
      let data_period_y: Array<any> = [];
      let data_period_onlineReport: Array<any> = [];
      for (var j = 0; j < Reports.L2[i].length; ++j) {
        if(windowWidth <= 1000) {
            arr.push({'reportID':Reports.L2[i][j].reportID, 'SN':Reports.L2[i][j].SN, 'Band':Reports.L2[i][j].Band, 'StartTime':Reports.L2[i][j].StartTime, 'OfflineReport':Reports.L2[i][j].OfflineReport, 'OnlineReport':Reports.L2[i][j].OnlineReport});
        } else {
            arr.push(Reports.L2[i][j]);
        }
        data_period_x.push(Reports.L2[i][j].StartTime);
        data_period_y.push(Reports.L2[i][j].MaxPower);
        data_period_onlineReport.push(Reports.L2[i][j].OnlineReport);
      }
      if (Reports.L2[i].length > 0) {
        data_period_.push({
          onlineReport: data_period_onlineReport,
          x: data_period_x,
          y: data_period_y,
          mode: 'markers',
          type: 'scatter',
          name: Reports.L2[i][0].SN + ' ' + Reports.L2[i][0].Band,
        });
      }
    }
    setReports(arr);
    setColumns(col);
    setPeriodData(data_period_);
    setEpoch(Reports.Time);
  }, [Reports.Time]);
  
  async function onClickDataPoint(data: any) {
console.log('data', data);
    if(data.points.length > 0) {
      window.open(data.points[0].data.onlineReport[data.points[0].pointIndex]);
    }
  }

  return (
    <div className="Status" style={{ overflowX: "visible" }}>
      <div className="status-body">
        <Table className="event-table">
          <TableBody>
            <TableRow>
              <TableCell
                style={{
                  width: "100%",
                  backgroundColor: "black",

                  maxWidth: "200px",
                  overflowX: "scroll",
                }}
                padding="none"
              >
                <Plot
                  data={data_period as any}
                  layout={layout_temp}
                  useResizeHandler={true}
                  style={{ width: "100%", height: "100%" }}
                  onClick={(data) => onClickDataPoint(data)}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                style={{
                  width: "100%",
                  backgroundColor: "black",
                }}
                padding="none"
              >
                <button onClick={onDownloadEventListClick}>
                  DOWNLOAD EVENT LIST
                </button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className="event_bottom_section"
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  overflowX: "hidden",

                  backgroundColor: "white",
                  margin: "0",
                }}
                padding="none"
              >
                <div>
                  <DataGrid
                    className="event_bottom_grid"
                    rows={reports}
                    style={{ width: "100%", maxWidth: "100%" }}
                    columns={columns}
                    getRowId={(row) => row.reportID}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                      },
                    }}
                    pageSizeOptions={[10]}
                  />
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
